import styled from '@emotion/styled';

export const DateLabel = styled('div')`
  color: ${(props) => props.theme.footer.color};
  font-size: 0.9em;
  white-space: nowrap;
`;
